import React from 'react';
import { PrivacyContent as SharedPrivacyContent } from './shared/PrivacyContent';

export const PrivacyContent: React.FC = () => {
  return (
    <div className="space-y-4 text-xs pb-8">
      <div className="text-center text-xs text-muted-foreground border-b border-border pb-3 mb-4">
        Effective Date: September 4, 2025 • Operated by Sébastien (EU) • Contact: forkast.in.app@gmail.com
      </div>
      <SharedPrivacyContent variant="modal" />
    </div>
  );
};